import React from "react";
import TimeSlideTranscript from "../../internal/TimeSlideTranscript/index";

const EditTranscript = ({ id, resolutionKind }) => {
  return (
    <div>
      <TimeSlideTranscript id={id} resolutionKind={resolutionKind} />
    </div>
  );
};

export default EditTranscript;
